import * as PID from '~/modules/retailMedia/components/CampaignForm/hooks/constants/publisherIds'

export const MAX_SIZE_UPLOAD = 1 // 1MB
export const MAX_SIZE_UPLOAD_BYTES = MAX_SIZE_UPLOAD * 1024 * 1024

export const MULTI_SIZE_VALIDATION_PUBLISHERS = [
  PID.FASTSHOP,
  PID.VTEX_GROCERY,
  PID.VTEX_GROCERY_B2B,
  PID.OLIMPICA_PID,
  PID.NEWTAILPARTNERBR
]

export const logoImageSizes = [
  {
    height: 100,
    width: 438,
    label: 'Brand',
    name: 'Brand',
    size: '438x100'
  },
  {
    height: 100,
    width: 100,
    label: 'Brand',
    name: 'Brand',
    size: '100x100'
  },
  {
    height: 400,
    width: 400,
    label: 'Brand',
    name: 'Brand',
    size: '400x400'
  }
]
